import "./App.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { AllRoutes } from "./lib/AllRoutes";
import Cart from "./UserSide/Pages/Cart/Cart";

function App() {
  return (
    <div className="App">

      <AllRoutes />
    </div>

  );
}

export default App;
